import React from 'react';
import { Home, List } from 'lucide-react';
import './screens/screens.css';

const FooterNavigation = ({ currentScreen, goToHome, goToAppList, isLoggedIn, isCreatingApp }) => {
  const scrollToTop = () => {
    // app-main-containerがスクロール可能な要素
    const scrollContainer = document.querySelector('.app-main-container');
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  };

  const handleHomeClick = () => {
    goToHome();
    scrollToTop();
  };

  const handleAppListClick = () => {
    if (isLoggedIn) {
      goToAppList();
    } else {
      // 未ログインの場合は未認証画面へ
      // この処理はApptukuApp.jsのhandleGoToAppListと同じロジック
      goToAppList(); // ApptukuApp.jsで未認証処理を行う
    }
    scrollToTop();
  };

  return (
    <nav className="FooterNav footer-nav">
      <div className="FooterNav_Container footer-nav-container">
        <button
          className={`FooterNav_Item footer-nav-item ${
            currentScreen === 'home' ? 'FooterNav_Item--active footer-nav-item--active' : ''
          }`}
          onClick={handleHomeClick}
          aria-label="ホーム"
        >
          <Home size={20} className="FooterNav_Icon footer-nav-icon" />
          <span className="FooterNav_Label footer-nav-label">ホーム</span>
        </button>

        <button
          className={`FooterNav_Item footer-nav-item ${
            currentScreen === 'appList' ? 'FooterNav_Item--active footer-nav-item--active' : ''
          }`}
          onClick={handleAppListClick}
          aria-label="アプリ一覧"
        >
          <List size={20} className="FooterNav_Icon footer-nav-icon" />
          <span className="FooterNav_Label footer-nav-label">アプリ一覧</span>
        </button>
      </div>
    </nav>
  );
};

export default FooterNavigation;